import { useCallback, useState } from "react";

export default function useAppContextState(initialState) {
    const [ state, setState ] = useState(initialState)

    const updateState = useCallback(newValue => {
        setState(oldValue => ({ ...oldValue, ...newValue }))
    }, [setState])

    const replaceState = useCallback(newValue => {
        setState(newValue)
    }, [setState])

    const resetState = useCallback(() => {
        setState(initialState)
    }, [setState, initialState])

    const updatePrevState = useCallback(updater => {
        setState(prevState => {
            return updater(prevState)
        })
    }, [setState])

    return {
        state,
        replaceState,
        resetState,
        updateState,
        updatePrevState,
        isModified: JSON.stringify(state) !== JSON.stringify(initialState)
    }
}